/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:50:50
 * @Last Modified by: Dac Hai
 * @Last Modified time: 2020-12-29 23:58:42
 */
import utils from '@/app/utils/gfUtils';

/**
 * Textarea template
 * @returns string
 */
export default (): string => {
  return `
<div id="md-text-area">
	<span class="md-title">
		<span class="mer-title">
			<i class="gpicon-form-textarea"></i>
			<span>Text Area</span>
		</span>
	</span>
	<div class="simple-tabs">
		<ul class="simple-tabs-item">
			<li>
				<a href="#">${utils.svgIcon('settings')} Settings </a>
			</li>
			<li>
				<a href="#">${utils.svgIcon('design')} Design </a>
			</li>
		</ul>
		<div class="md-body settings-panel"></div>
		<div class="md-body design-panel"></div>
		<textarea class="txtStyleHidden inptxt gf-hide"></textarea>
	</div>
	<div class="md-footer">
		<button class="btnSave">Save</button>
		<button class="btnCancel" class="cancel">Cancel</button>
	</div>
</div>
  `;
};
